import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { withAppUser } from '../shared/authorization/userConsumer';
import { Dashboard } from '../dashboard';

/**
 * `/` → Dashboard when signed in, otherwise marketing landing at /welcome.
 */
const RootDefaultInner = ({
  user,
  isUserLoading,
}: {
  user: ?Object,
  isUserLoading: boolean,
}) => {
  if (isUserLoading) {
    return null;
  }
  if (user) {
    return <Dashboard />;
  }
  return <Redirect to="/welcome" />;
};

export default withAppUser(RootDefaultInner);
